import React, { useCallback, useState } from 'react'
import { Modal } from 'components/Utility/Modal/Modal'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import { Stars } from 'components/Utility/Stars/Stars'
import styles from './Modals.module.scss'

const QUESTIONS = [
  'Качество оказанной услуги',
  'Время обслуживания',
  'Чистота в салоне',
  'Атмосфера в салоне',
  'Общее впечатление от посещения салона',
]

/** answer1…answer5, 1–5 stars each */
export type ReviewAnswers = Record<string, number>

export type RateForm = {
  answers: ReviewAnswers,
  comment: string,
}

const initialAnswers = (): ReviewAnswers => Object.fromEntries(QUESTIONS.map((_, i) => [`answer${i + 1}`, 5]))

type RateModalProps = {
  isOpen?: boolean,
  submitting?: boolean,
  onClose: () => void,
  onSubmit: (form: RateForm) => void,
}

/** Five star questions and a comment about a past visit */
export const RateModal: React.FC<RateModalProps> = (props) => {
  const { isOpen = false, submitting = false, onClose, onSubmit } = props
  const [answers, setAnswers] = useState(initialAnswers)
  const [comment, setComment] = useState('')

  const handleSubmit = useCallback(() => {
    onSubmit({ answers, comment })
    setComment('')
  }, [onSubmit, answers, comment])

  return (
    <Modal isOpen={isOpen} className={styles.container} title={'Оставить отзыв'} onClose={onClose}>
      <div className={styles.fieldsContainer}>
        {QUESTIONS.map((title, i) => {
          const name = `answer${i + 1}`
          return (
            <div key={name} className={styles.rateField}>
              <div className={styles.fieldTitle}>{title}</div>
              <div className={styles.starsContainer}>
                <Stars
                  name={name}
                  value={answers[name]}
                  onChange={(value) => setAnswers((current) => ({ ...current, [name]: value }))}
                />
              </div>
            </div>
          )
        })}
        <div className={styles.field}>
          <textarea
            className={styles.textarea}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={'Комментарий'}
          />
        </div>
      </div>
      <AppButton disabled={submitting} onClick={handleSubmit} className={styles.button}>
        Оставить отзыв
      </AppButton>
    </Modal>
  )
}
